import React, {PureComponent} from 'react';
import {Button, Heading, Paper, Text} from '@hawkins/components';
import {Link} from "react-router-dom";

export default class Error404 extends PureComponent<{}, {}> {
    render() {
        return <Paper>
            <Heading level={5}>We can’t find what you’re looking for</Heading>
            <Text>Sorry about that! It looks like this page does not exist.<br/>
                Contact #security-help if you think this is a mistake.</Text>
            <Link to='/'><Button>Back to Home</Button></Link>
        </Paper>
    }
}
